const zeroPadding = (count)=>{
    const absoluteCount = Math.abs(count);
    const minus = count < 0 ? '-' : '';
    const zero = absoluteCount < 10 ? '0' : '';
    return `${minus}${zero}${absoluteCount}`;
};
export { zeroPadding };
